import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ContactPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    subject: 'general'
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission - in real app, this would send to backend
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ name: '', email: '', message: '', subject: 'general' });
    }, 3000);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div style={{
      minHeight: '100vh',
      width: '100%',
      fontFamily: "'Nunito', sans-serif",
      backgroundColor: '#F4ABBA',
      color: '#333',
      padding: '40px 20px',
      paddingTop: '100px'
    }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <button
          onClick={() => navigate('/')}
          style={{
            backgroundColor: 'white',
            color: '#DD2E44',
            padding: '10px 25px',
            borderRadius: '20px',
            border: '2px solid #DD2E44',
            fontSize: '16px',
            fontWeight: '700',
            cursor: 'pointer',
            marginBottom: '40px'
          }}
        >
          ← Back to Home
        </button>

        <div style={{
          backgroundColor: 'white',
          padding: '60px',
          borderRadius: '25px',
          boxShadow: '0 8px 30px rgba(0,0,0,0.1)'
        }}>
          <h1 style={{
            fontSize: '48px',
            fontWeight: '800',
            color: '#DD2E44',
            marginBottom: '20px',
            textAlign: 'center'
          }}>
            Contact Us
          </h1>
          <p style={{
            fontSize: '20px',
            color: '#666',
            textAlign: 'center',
            marginBottom: '40px'
          }}>
            Have questions? We'd love to hear from you! 💝
          </p>

          {submitted ? (
            <div style={{
              textAlign: 'center',
              padding: '40px',
              backgroundColor: '#A8E6CF',
              borderRadius: '20px',
              marginBottom: '30px'
            }}>
              <div style={{ fontSize: '64px', marginBottom: '20px' }}>✅</div>
              <h2 style={{ fontSize: '32px', color: '#DD2E44', marginBottom: '10px' }}>
                Thank You!
              </h2>
              <p style={{ fontSize: '20px', color: '#666' }}>
                We've received your message and will get back to you soon!
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ maxWidth: '600px', margin: '0 auto' }}>
              <div style={{ marginBottom: '25px' }}>
                <label style={{
                  display: 'block',
                  fontSize: '18px',
                  fontWeight: '600',
                  color: '#DD2E44',
                  marginBottom: '10px'
                }}>
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '15px',
                    borderRadius: '15px',
                    border: '2px solid #DD2E44',
                    fontSize: '16px',
                    fontFamily: "'Nunito', sans-serif",
                    outline: 'none',
                    transition: 'all 0.3s ease'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#EA596E';
                    e.target.style.boxShadow = '0 0 0 3px rgba(221, 46, 68, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#DD2E44';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </div>

              <div style={{ marginBottom: '25px' }}>
                <label style={{
                  display: 'block',
                  fontSize: '18px',
                  fontWeight: '600',
                  color: '#DD2E44',
                  marginBottom: '10px'
                }}>
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '15px',
                    borderRadius: '15px',
                    border: '2px solid #DD2E44',
                    fontSize: '16px',
                    fontFamily: "'Nunito', sans-serif",
                    outline: 'none',
                    transition: 'all 0.3s ease'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#EA596E';
                    e.target.style.boxShadow = '0 0 0 3px rgba(221, 46, 68, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#DD2E44';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </div>

              <div style={{ marginBottom: '25px' }}>
                <label style={{
                  display: 'block',
                  fontSize: '18px',
                  fontWeight: '600',
                  color: '#DD2E44',
                  marginBottom: '10px'
                }}>
                  Subject
                </label>
                <select
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '15px',
                    borderRadius: '15px',
                    border: '2px solid #DD2E44',
                    fontSize: '16px',
                    fontFamily: "'Nunito', sans-serif",
                    outline: 'none',
                    cursor: 'pointer',
                    backgroundColor: 'white'
                  }}
                >
                  <option value="general">General Inquiry</option>
                  <option value="support">Technical Support</option>
                  <option value="partnership">Partnership</option>
                  <option value="feedback">Feedback</option>
                </select>
              </div>

              <div style={{ marginBottom: '30px' }}>
                <label style={{
                  display: 'block',
                  fontSize: '18px',
                  fontWeight: '600',
                  color: '#DD2E44',
                  marginBottom: '10px'
                }}>
                  Message
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  style={{
                    width: '100%',
                    padding: '15px',
                    borderRadius: '15px',
                    border: '2px solid #DD2E44',
                    fontSize: '16px',
                    fontFamily: "'Nunito', sans-serif",
                    outline: 'none',
                    resize: 'vertical',
                    transition: 'all 0.3s ease'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#EA596E';
                    e.target.style.boxShadow = '0 0 0 3px rgba(221, 46, 68, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#DD2E44';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </div>

              <button
                type="submit"
                style={{
                  width: '100%',
                  backgroundColor: '#DD2E44',
                  color: 'white',
                  padding: '20px',
                  borderRadius: '25px',
                  border: 'none',
                  fontSize: '20px',
                  fontWeight: '700',
                  cursor: 'pointer',
                  boxShadow: '0 6px 20px rgba(221, 46, 68, 0.3)',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-3px)';
                  e.target.style.boxShadow = '0 8px 25px rgba(221, 46, 68, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 6px 20px rgba(221, 46, 68, 0.3)';
                }}
              >
                Send Message 💌
              </button>
            </form>
          )}

          <div style={{
            marginTop: '50px',
            padding: '30px',
            backgroundColor: '#FFF5F7',
            borderRadius: '20px',
            textAlign: 'center'
          }}>
            <h3 style={{ fontSize: '24px', fontWeight: '700', color: '#DD2E44', marginBottom: '15px' }}>
              Other Ways to Reach Us
            </h3>
            <div style={{ fontSize: '18px', color: '#666' }}>
              <p style={{ marginBottom: '10px' }}>📧 Email: hello@paria.ai</p>
              <p>🌐 Website: paria.ai</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;